'use client'

import { Suspense, useMemo } from 'react'
import Link from 'next/link'
import { useSearchParams } from 'next/navigation'
import { AuthLayout } from '@/components/auth/AuthLayout'
import { RegisterForm } from '@/components/auth/RegisterForm'
import { useI18n } from '@/components/I18nProvider'

export default function RegisterPage() {
  const { t } = useI18n()

  return (
    <AuthLayout
      title={t({ es: 'Crea tu cuenta BPAL', en: 'Create your BPAL account' })}
      subtitle={t({ es: 'Abre tu acceso con invitacion o referral y entra en minutos.', en: 'Open your access with an invitation or referral and get started in minutes.' })}
      topActionHref="/login"
      topActionLabel={t({ es: 'Iniciar sesion', en: 'Sign in' })}
      footer={
        <div className="text-sm text-muted">
          {t({ es: 'Ya tienes cuenta?', en: 'Already have an account?' })}{' '}
          <Link href="/login" className="font-medium text-[#0f766e] hover:underline">
            {t({ es: 'Iniciar sesion', en: 'Sign in' })}
          </Link>
        </div>
      }
    >
      <Suspense fallback={<RegisterForm />}>
        <RegisterFormWithRef />
      </Suspense>
    </AuthLayout>
  )
}

function RegisterFormWithRef() {
  const searchParams = useSearchParams()
  const referralFromUrl = useMemo(() => {
    const ref = (searchParams.get('ref') || '').trim().toUpperCase()
    return ref || null
  }, [searchParams])

  return <RegisterForm referralFromUrl={referralFromUrl} />
}
